/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import './AutoVerify.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { getCustomer } from 'state/customer/CustomerSelectors';
import { getView } from 'state/view/ViewSelectors';
import {
  addVerifiedBank,
  getBankProfile,
  updateBankVerificationStatus
} from 'services/Rest';

import { getENV, TRP_ENVIRONMENTS } from 'services/globals';
import {
  formatBankAccount,
  isInitiated,
  isVerified
} from 'services/LinkedBankAccounts';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';

class AutoVerify extends React.Component {
  state = {
    processing: false
  };

  updateProcessing = (flag) => {
    this.setState({
      processing: flag
    });
  };

  performVerification = () => {
    const { bankAccount } = this.props;
    this.updateProcessing(true);
    const formatBankKey = formatBankAccount(bankAccount);
    updateBankVerificationStatus(formatBankKey).then(() => {
      addVerifiedBank(formatBankKey).then(() => {
        this.updateProcessing(false);
        getBankProfile();
      });
    });
  };

  updateStatus = () => {
    this.updateProcessing(true);
    const { bankAccount } = this.props;
    const formatBankKey = formatBankAccount(bankAccount);
    updateBankVerificationStatus(formatBankKey).then(() => {
      this.updateProcessing(false);
      getBankProfile();
    });
  };

  render() {
    const { bankAccount } = this.props;
    const { processing } = this.state;
    const { bankVerificationStatus } = bankAccount;

    if (getENV() === TRP_ENVIRONMENTS.PRODUCTION) {
      return null;
    }
    if (!isVerified(bankVerificationStatus)) {
      return (
        <div className="auto-verify-container">
          {!isInitiated(bankVerificationStatus) && (
            <Fragment>
              <button onClick={this.performVerification} className="button">
                {processing ? <Spinner /> : 'Automatically Verify Bank'}
              </button>
              <span className="error-text">
                {' '}
                WARNING - will move bank to verified status in the database.
              </span>
            </Fragment>
          )}
          {isInitiated(bankVerificationStatus) && (
            <Fragment>
              <button onClick={this.updateStatus} className="button">
                {processing ? <Spinner /> : 'Auto-Prepare Micro Deposits'}
              </button>
              <span className="error-text">
                {' '}
                WARNING - will update status to 30 in the database.
              </span>
            </Fragment>
          )}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  customer: getCustomer(state),
  view: getView(state)
});

export default connect(mapStateToProps)(AutoVerify);
